// extracted by mini-css-extract-plugin
export default {"gridContainerSingleRowLayoutSpaced":"Index_gridContainerSingleRowLayoutSpaced__pCwI5"};